/**
 * Rate limiter fitted under a works agreement nobody has been able to repeal.
 */

import type { Affix } from '@/sim/items/affixContract';

export const UNION_MANDATE = {
  id: 'unionMandate',
  slot: 'suffix',
  field: 'fireRate',
  direction: -1,
  label: 'Reduced fire rate',
  nameWord: 'of the Union Mandate',
  ranges: {
    common: { min: 0.03, max: 0.06 },
    uncommon: { min: 0.05, max: 0.09 },
    rare: { min: 0.08, max: 0.13 },
    exotic: { min: 0.11, max: 0.17 },
  },
} as const satisfies Affix;
